'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _modifiers = require('../../modifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  flex: 1;\n  text-transform: capitalize;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var modifierConfig = _extends({}, _modifiers.fontColors, _modifiers.fontStyles, _modifiers.fontWeights, _modifiers.spacing);

var themePropTypes = _extends({}, _modifiers.fontColorPropTypes, _modifiers.fontWeightPropTypes, customThemePropTypes, _modifiers.spacingPropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Label', _styledComponents2.default.label, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/Label/index.js
// module id = 1525
// module chunks = 2